import { render, staticRenderFns } from "./TemplateBankView.vue?vue&type=template&id=2c49d7b1"
import script from "./TemplateBankView.vue?vue&type=script&lang=js"
export * from "./TemplateBankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports